export default __webpack_public_path__ + "static/media/closet3-1920w.00940860.webp";